<div
  class="relative rounded-lg shadow-sm font-title font-medium text-sm"
  [class.opacity-50]="isDisabled()"
>
  <button
    type="button"
    class="h-11 w-full appearance-none rounded-lg border border-gray-300 bg-white
           px-4 py-2.5 pr-11 text-sm shadow-theme-xs text-left
           focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10
           dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 {{ className() }}"
    [class.text-gray-800]="multipleText()"
    [class.dark:text-white]="multipleText()"
    [class.text-gray-400]="!multipleText()"
    [disabled]="isDisabled()"
    (click)="openModal()"
  >
    {{ multipleText() ?? placeholder() }}
  </button>

 <lib-icon
    name="chevron-down"
    class="absolute text-gray-700 dark:text-gray-400 right-3 top-1/2 -translate-y-1/2 pointer-events-none text-xl"
  ></lib-icon>
</div>